import { Button, FormCheck } from "react-bootstrap";
import "./user-management.component.scss";
import { useEffect, useState } from "react";
import SEARCH from "../../assets/images/search.svg";
import UPLOAD_ICON from "../../assets/images/upload.svg";
import TableWithPagination from "../dashboard/table/dashboard-table.component";
import InviteUser from "../../modal/invite-user/invite-user";
import UserManagementTableWithPagination from "./table/user-management-table.component";
import { ProfileModel } from "../../model/profile.model";
import { deleteUser, getUserCount, getUsers } from "../../services/api.service";
import { getIdToken } from "firebase/auth";
import { useAuth } from "../../utility/use-auth";
import { auth, db } from "../../firebase/auth.firebase";
import { useSnackbar } from "../../utility/snackbar.utility";
import CustomSnackbar from "../../components/snackbar/snackbar.component";
import { TotalUserCountModel } from "../../model/total-users.model";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import ConfirmModal from "../../modal/confirm/confirm.component";
import config from "../../config";
interface NameOption {
    value: string;
    label: string;
}
const UserManagementComponent = () => {
    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();
    const { user, loading } = useAuth();
    const [searchTitle, setSearchTitle] = useState("");
    const [isShowInviteUser, setIsShowInviteUser] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);
    const [listUsers, setListUsers] = useState<ProfileModel[]>();
    const [listUsersDefault, setListUsersDefault] = useState<ProfileModel[]>();
    const [totalUser, setTotalUser] = useState<TotalUserCountModel>();
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
    const [selectedId, setSelectedId] = useState<ProfileModel>();
    const [isEdit, setIsEdit] = useState(false);
    const [profileEdit, setProfileEdit] = useState<ProfileModel>();
    useEffect(() => {
        getAllUsers();
    }, [])
    const getAllUsers = () => {
        getTotalUserCount();
        getUsers().then((res) => {

            if (res && res.length > 0) {
                setListUsersDefault(res);
                setListUsers(res);
            }
        })
    }

    const getTotalUserCount = () => {

        getUserCount().then((res: any) => {
            setTotalUser(res);
        })
    }


    const clickAddUser = () => {
        setIsShowInviteUser(true);
    }

    const clickDeleteUser = (id: ProfileModel) => {
        setSelectedId(id);
        setIsShowConfirmModal(true);
    }

    const clickEditUser = (id: ProfileModel) => {
        setIsShowInviteUser(true);
        setIsEdit(true);
        setProfileEdit(id);
    }

    const handleCloseConfirmDeleteModal = async (confirm: boolean) => {
        setIsShowConfirmModal(false);
        if (!confirm || !selectedId) return;

        // Get the ID token for the signed-in user
        const user = auth.currentUser;

        if (!user) {
            // setError('No user is signed in.');
            return;
        }

        const token = await getIdToken(user, true); // Set 'true' to force refresh the token
        const logRef = collection(db, "logs");
        const logDelete = await addDoc(logRef, {
            timestamp: serverTimestamp(),
            user_id: user.uid,
            user_email: user.email,
            action_type: "DELETE",
            previous_data: { email: selectedId.email, "role": selectedId.role }
        })
        if (logDelete) {
            deleteUser(selectedId.uuid, token).then((res: any) => {
                if (res) {
                    getAllUsers();
                }
            })
        }

    };

    const handleSearch = (searchValue) => {
        setSearchTitle(searchValue);
        if (listUsersDefault && listUsersDefault.length > 0) {
            const listMod = [...listUsersDefault];
            setListUsers(listMod.filter((item) => item.email?.includes(searchValue)));
        }
    }

    const onComplete = async (email, role) => {

        showSnackbar("ส่งคำเชิญเข้าใช้งานระบบให้ " + email + " เรียบร้อยแล้ว", "success", 4000);
        // Log the logout action in Firestore
        if (user) {
            if (!auth.currentUser) return; // Ensure user is logged in before logging out

            const userAuthen = auth.currentUser;
            const logRef = collection(db, "logs");
            await addDoc(logRef, {
                timestamp: serverTimestamp(),
                user_id: userAuthen.uid,
                user_email: userAuthen.email,
                action_type: "INVITE",
                new_data: { email: email, role: role }
            });
        }

        getAllUsers();
    }

    const onCompleteEdit = async (email, role) => {

        showSnackbar("แก้ไขข้อมูลผู้ใช้งาน " + email + " เรียบร้อยแล้ว", "success", 4000);
        
        getAllUsers();
    }

    const handleCloseInviteUser = () => {
        setIsEdit(false);
        setIsShowInviteUser(false)
    }

    return (
        <>
            <div className="users-management-control">
                <div className="users-management-main-control">

                    <div className="users-management-main-top-control">
                        <span className="users-management-main-top-text">จัดการผู้ใช้งาน</span>
                        <Button className="users-management-upload-video-button" onClick={clickAddUser}>เพิ่มผู้ใช้งาน</Button>
                    </div>
                    <div className="users-management-search-control">
                        <div className="users-management-search-form-control">
                            <div>
                                <img src={SEARCH} className="users-management-search-icon"></img>
                                <input
                                    className="users-management-search-form"
                                    type="text"
                                    id="search"
                                    placeholder="ค้นหาด้วยอีเมล"
                                    value={searchTitle}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                        </div>
                        <Button className="users-management-search-button">ค้นหา</Button>

                        <div className="users-management-total-control">
                            <span className="users-management-total-title">จำนวนผู้ใช้งาน:
                            </span>
                            <span className="users-management-total-admin">
                                {totalUser && totalUser.totalAdmins > 0 ? "Admin: " + totalUser.totalAdmins + " / "+config.users.admin : "Admin : 0 / "+config.users.admin}
                            </span>
                            <span className="users-management-total-staff"> {totalUser && totalUser.totalStaff > 0 ? "Staff: " + totalUser.totalStaff + " / "+config.users.staff : "Staff : 0 / "+config.users.staff}</span>

                        </div>
                    </div>
                </div>
                <div className="users-management-content-control">
                    <div className="users-management-content-item-control">
                        {
                            isEmpty ?
                                <div className="users-management-content-empty-control">
                                    <img src={UPLOAD_ICON} className="users-management-content-empty-icon"></img>
                                    <span className="users-management-content-empty-title">ยังไม่มีรายการผู้ใช้งาน</span>
                                    <span className="users-management-content-empty-desc">กรุณาเพิ่มผู้ใช้งาน</span>
                                    <Button className="users-management-content-empty-upload-button" onClick={clickAddUser}>เพิ่มผู้ใช้งาน</Button>
                                </div> : listUsers && listUsers.length > 0 && <>
                                    <UserManagementTableWithPagination listUsersMod={listUsers} 
                                    clickEditUser={clickEditUser}
                                    clickDeleteUser={clickDeleteUser}></UserManagementTableWithPagination>
                                </>
                        }

                    </div>
                </div>
            </div>

            {
                isShowInviteUser &&
                <InviteUser isEdit={isEdit} profileEdit={profileEdit}  show={isShowInviteUser} onClose={handleCloseInviteUser} 
                onComplete={onComplete}
                onCompleteEdit={onCompleteEdit} ></InviteUser>
            }

            {
                isShowConfirmModal && <ConfirmModal show={isShowConfirmModal} type="delete" onClose={handleCloseConfirmDeleteModal} />
            }

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )
}

export default UserManagementComponent;